/**
 * Owner: Masa Bayu
 * File: studio-commands.ts
 * Date:Time: 2026-10-24 20:40
 * Description: D3 · kontrak bar Studio tunggal — enjin mendaftarkan keadaan + arahan,
 *   host (qxread /author/studio) yang render satu bar. Tiada React, tiada DOM.
 */
const EMPTY_VIEW = { embedded: false, state: {}, commands: {} };
const registrations = new Map();
const listeners = new Set();
let embedded = false;
let view = EMPTY_VIEW;
/** Kunci cat Import — tidak dilenyapkan oleh register writer semula dengan busy=false. */
let importProgress = null;
function recompute() {
    let state = {};
    let commands = {};
    for (const registration of registrations.values()) {
        state = { ...state, ...registration.state };
        commands = { ...commands, ...registration.commands };
    }
    if (importProgress !== null) {
        state = {
            ...state,
            importBusy: true,
            ...(importProgress.importHint !== undefined
                ? { importHint: importProgress.importHint }
                : {}),
            ...(importProgress.importFailed === true ? { importFailed: true } : {}),
        };
    }
    view = { embedded, state, commands };
    for (const listener of listeners)
        listener();
}
export function setQxStudioImportProgress(next) {
    if (!next.importBusy) {
        importProgress = null;
    }
    else {
        const locked = { importBusy: true };
        if (next.importHint !== undefined)
            locked.importHint = next.importHint;
        if (next.importFailed === true)
            locked.importFailed = true;
        importProgress = locked;
    }
    recompute();
}
/** true = enjin sedang dimount di dalam host Studio; enjin berdiri sendiri (5180/5174) tidak. */
export function setQxStudioEmbedded(next) {
    if (next === embedded)
        return;
    embedded = next;
    recompute();
}
export function isQxStudioEmbedded() {
    return embedded;
}
/** Gantikan seluruh sumbangan satu enjin; panggil lagi setiap perubahan keadaan. */
export function registerQxStudioCommands(source, next) {
    registrations.set(source, next);
    recompute();
}
/** Buang sumbangan enjin apabila ia dibuang dari DOM. */
export function clearQxStudioCommands(source) {
    if (!registrations.delete(source))
        return;
    recompute();
}
export function getQxStudioView() {
    return view;
}
export function subscribeQxStudio(listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
/** Untuk ujian/pembacaan sekali; komponen React guna `subscribeQxStudio`. */
export function resetQxStudioRegistry() {
    registrations.clear();
    embedded = false;
    importProgress = null;
    recompute();
}
//# sourceMappingURL=studio-commands.js.map